function snakeToCamel(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_match, char: string) => char.toUpperCase());
}

function camelToSnake(key: string): string {
  return key.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

export function keysToCamel<T = unknown>(value: unknown): T {
  return convert(value, snakeToCamel) as T;
}

export function keysToSnake<T = unknown>(value: unknown): T {
  return convert(value, camelToSnake) as T;
}

/**
 * The wire is `snake_case` and TypeScript is `camelCase`; this is the only
 * place in the app that knows it. Keys are renamed, values never are — a
 * caption she pasted or a prompt body passes through as written.
 */
function convert(value: unknown, rename: (key: string) => string): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => convert(item, rename));
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, entryValue] of Object.entries(value as Record<string, unknown>)) {
      result[rename(key)] = convert(entryValue, rename);
    }
    return result;
  }
  return value;
}
